module.exports = __webpack_public_path__ + "img/logo.4db7cd46.png";